export const TOKEN = "token";
export const USER = "user";
export const DISPLAY = "display";
export const D_INV010 = "d_inv010";
export const D_INV170 = "d_inv170";